/* eslint-disable @typescript-eslint/no-require-imports, @typescript-eslint/no-unsafe-assignment */
import { styled } from '@mui/material';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type ViewProductStore from '../../AppData/_stores/ViewProductStore';
import { useAppSelector } from '../../Common/_hooks/useAppSelector';

interface ProductCatalogPrintTypeTagProps {
  product: ViewProductStore
}

const PrintTypeTag = styled('div')(({ theme }) => ({
  alignItems: 'flex-start',
  color: 'var(--product-catalog-card-print-color, ' + theme.palette.accent.main + ')',
  display: 'inline-flex',
  fontSize: '14px',
  fontWeight: 600,
  textTransform: 'uppercase',
  transition: 'color 250ms',

  'img': {
    marginRight: '5px',
    width: '20px',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '11px',

    'img': {
      width: '16px',
    }
  },
}));

function ProductCatalogPrintTypeTag(props: ProductCatalogPrintTypeTagProps) {
  const [t] = useTranslation('products');
  const viewProductAttributeTypes = useAppSelector(state => state.get('appData').get('viewProductAttributeTypes'));
  const viewProductAttributeValues = useAppSelector(state => state.get('appData').get('viewProductAttributeValues'));
  const printType = useMemo(() => {
    const printTypeAttrType = viewProductAttributeTypes.find(type => type.get('slug') === 'print-type');
    if (!printTypeAttrType) return undefined;

    const valueId = props.product.get('listAttributes').get(String(printTypeAttrType.get('id')));
    if (valueId === undefined) return undefined;

    return viewProductAttributeValues.get(String(valueId));
  }, [props.product, viewProductAttributeTypes, viewProductAttributeValues])

  if (printType === undefined) {
    return null;
  }

  return <PrintTypeTag>
    <img src={require('@resources/img/all-products/filters/' + printType.get('slug') + '.svg?url')} alt={t('All-over print Icon')} />
    {printType.get('name')}
  </PrintTypeTag>;
}

export default memo(ProductCatalogPrintTypeTag);
